export const AdversaryModel = {
  name: { type: "text" },
  region: { type: "text" },
  active: { type: "boolean" },
  type: {
    type: "enum",
    options: [
      { label: "Bot", value: "Bot" },
      { label: "APT", value: "APT" },
      { label: "Insider", value: "Insider" },
      { label: "Ransomware", value: "Ransomware" },
    ],
  },
  aliases: { type: "list" },
};
